module.exports = __webpack_public_path__ + "img/GruendungsbueroKL.4c29373d.svg";